import { useLangFromQueryParam } from '../hooks/useLangFromQueryParam';

export function LanguageSync() {
	useLangFromQueryParam();
	return null;
}
